import React from "react";
import CommonModal from "../../components/Modal";
import { ModalProps } from "../../components/Modal/Modal.types";
import { useTranslation } from "react-i18next";

const CampaignLimitWarningModal: React.FC<ModalProps> = ({
  open,
  onClose,
  onConfirm,
}) => {
  const { t } = useTranslation();

  return (
    <CommonModal
      visible={open}
      background="#fff7e0"
      confirmText={t("phishingManager.campaignLimitWarningModal.confirmText")}
      cancelText={t("phishingManager.campaignLimitWarningModal.cancelText")}
      iconType={"phishingManagerWarningModal"}
      modalContentTitle={t("phishingManager.campaignLimitWarningModal.title")}
      modalContentDesc={[
        t("phishingManager.campaignLimitWarningModal.description.line1"),
        t("phishingManager.campaignLimitWarningModal.description.line2"),
        t("phishingManager.campaignLimitWarningModal.description.line3"),
      ]}
      onClose={onClose}
      onConfirm={onConfirm}
    />
  );
};

export default CampaignLimitWarningModal;